const Breakpoints = {};

Breakpoints.currentBreakpoint = null;
Breakpoints.previousBreakpoint = null;

const values = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1496,
}

Breakpoints.getValues = () => {
    return values;
};

Breakpoints.getViewportWidth = () => {
    return document.body.clientWidth;
};

Breakpoints.getCurrentBreakpoint = () => {
    let currentBreakpoint;

    const currentWidth = Breakpoints.getViewportWidth();

    switch (true) {
        case currentWidth < Breakpoints.getValues().sm:
            currentBreakpoint = 'sm';
            break;
        case currentWidth < Breakpoints.getValues().md:
            currentBreakpoint = 'md';
            break;
        case currentWidth < Breakpoints.getValues().lg:
            currentBreakpoint = 'lg';
            break;
        case currentWidth < Breakpoints.getValues().xl:
            currentBreakpoint = 'xl';
            break;
        case currentWidth < Breakpoints.getValues()['2xl']:
            currentBreakpoint = '2xl';
            break;
        default:
            currentBreakpoint = 'default'
            break;
    }

    if (currentBreakpoint !== Breakpoints.currentBreakpoint) {
        Breakpoints.previousBreakpoint = Breakpoints.currentBreakpoint;
    }

    Breakpoints.currentBreakpoint = currentBreakpoint;

    return;
}

Breakpoints.getCurrentBreakpoint();

window.addEventListener('resize', () => {
    Breakpoints.getCurrentBreakpoint();
});

export default Breakpoints;
